import React from "react";

const DEFAULT_MESSAGE =
  "This page is currently available in English only. You can use your browser’s translate feature.";

const Notice = ({ message, appLang }) => {
  const app = (appLang || document.documentElement.lang || "en").toLowerCase();
  const user = (
    typeof navigator !== "undefined" && navigator.language
      ? navigator.language
      : "en-GB"
  ).toLowerCase();

  const show = !user.startsWith(app);
  if (!show) return null;

  return (
    <section aria-labelledby="notice-title">
      <hr />
      <p role="note" style={{ opacity: 0.8 }}>
        {message || DEFAULT_MESSAGE}
      </p>
    </section>
  );
};

export default Notice;
